import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import React from 'react';

countries.registerLocale(enLocale);

const COUNTRY_FLAG_BASE_URL =
  'https://www.benzinga.com/wp-content/themes/benzinga-money/dist/rebuild/images/icons/countries-flags/alpha3';
const ISO_ALPHA_3_PATTERN = /^[A-Z]{3}$/;

export interface CountryFlagIconProps {
  className?: string;
  code: string | null | undefined;
}

export const CountryFlagIcon: React.FC<CountryFlagIconProps> = ({ className, code }) => {
  const normalizedCode = React.useMemo(() => {
    return typeof code === 'string' ? code.toUpperCase() : null;
  }, [code]);

  const countryName = React.useMemo(() => {
    if (!normalizedCode || !ISO_ALPHA_3_PATTERN.test(normalizedCode)) {
      return '';
    }
    return countries.getName(normalizedCode, 'en') || normalizedCode;
  }, [normalizedCode]);

  const FlagImg = React.useMemo(() => {
    return <img alt={countryName} className={className} src={`${COUNTRY_FLAG_BASE_URL}/${normalizedCode}.svg`} />;
  }, [countryName, className, normalizedCode]);

  if (!normalizedCode || !ISO_ALPHA_3_PATTERN.test(normalizedCode)) {
    return null;
  }

  return <span title={countryName}>{FlagImg}</span>;
};
